import I from "../component/Icon";
import React, { useCallback, useEffect, useMemo, useState, } from "react";
import { createPortal } from "react-dom";
import apiService from "../services/apiService";
import StudentForm from "../component/StudentForm";
import StudentView from "../component/StudentView";
import UploadExcel from "../component/uploadExcel";
import SB from "../component/SearchBox";
import Bdg from "../component/Badge";
import ExamPills from "../component/ExamPills";
import ConfirmDlg from "../component/ConfirmDialog";

const STUDENT_API =
  "Student/getPaginatedStudent";

const GET_STUDENT_BY_ID_API =
  "Student/getStudentById";

const DELETE_STUDENT_API =
  "Student/deleteStudent";

const STANDARD_API =
  "StandardMaster/getAllStandardMasters";

const SCHOOL_API =
  "School/getAllSchool";

const EXAM_API =
  "Exam/getAllExam";

const RAZORPAY_ORDER_API =
  "Payment/createRazorpayOrder";

const RAZORPAY_KEY_ID =
  "rzp_live_TkB8Olj4FbJVxc";

const RAZORPAY_VERIFY_API =
  "Payment/verifyRazorpayPayment";


const ITEMS_PER_PAGE = 10;

const ACTIVE_STATUS_ID = 1;


const showNotification = (type, message) => {
  if (
    typeof document === "undefined" ||
    typeof window === "undefined"
  ) {
    return;
  }

  const existingNotification =
    document.getElementById(
      "students-page-notification"
    );

  if (existingNotification) {
    existingNotification.remove();
  }

  const notification =
    document.createElement("div");

  notification.id =
    "students-page-notification";

  notification.textContent =
    `${type === "success" ? "✓" : "✕"} ${message}`;

  Object.assign(
    notification.style,
    {
      position: "fixed",
      top: "20px",
      right: "20px",
      zIndex: "99999",
      minWidth: "280px",
      maxWidth: "420px",
      padding: "12px 16px",
      borderRadius: "8px",
      backgroundColor:
        type === "success"
          ? "#d1e7dd"
          : "#f8d7da",
      color:
        type === "success"
          ? "#0f5132"
          : "#842029",
      border:
        type === "success"
          ? "1px solid #badbcc"
          : "1px solid #f5c2c7",
      fontSize: "14px",
      fontWeight: "600",
      boxShadow:
        "0 4px 12px rgba(0,0,0,0.15)",
    }
  );

  document.body.appendChild(
    notification
  );

  window.setTimeout(() => {
    if (notification.parentNode) {
      notification.remove();
    }
  }, 3000);
};

const getApiErrorMessage = (
  error,
  fallback
) => {
  const data =
    error?.response?.data;

  if (
    typeof data === "string" &&
    data.trim()
  ) {
    return data;
  }

  if (
    data &&
    typeof data === "object"
  ) {
    if (
      data?.errors &&
      typeof data.errors === "object"
    ) {
      const validationErrors =
        Object.values(data.errors)
          .flat()
          .filter(Boolean)
          .join(" ");

      if (validationErrors) {
        return validationErrors;
      }
    }

    return (
      data?.failureReason ||
      data?.FailureReason ||
      data?.message ||
      data?.Message ||
      data?.title ||
      data?.error ||
      error?.message ||
      fallback
    );
  }

  return (
    error?.message ||
    fallback
  );
};

const numberValue = (value) => {
  if (
    value === undefined ||
    value === null ||
    value === ""
  ) {
    return 0;
  }

  const cleaned = String(value)
    .replace(/,/g, "")
    .replace(/[^0-9.]/g, "");

  const result = Number(cleaned);

  return Number.isFinite(result)
    ? result
    : 0;
};

const parseMaybeJson = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return value;
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
};

const extractList = (payload) => {
  if (!payload) {
    return [];
  }

  let root = parseMaybeJson(payload);

  if (Array.isArray(root)) {
    return root;
  }

  const candidates = [
    root?.output,
    root?.Output,

    root?.data,
    root?.Data,

    root?.result,
    root?.Result,

    root?.items,
    root?.Items,

    root?.records,
    root?.Records,

    root?.list,
    root?.List,
  ];

  for (let candidate of candidates) {
    candidate =
      parseMaybeJson(candidate);

    if (Array.isArray(candidate)) {
      return candidate;
    }

    if (
      candidate &&
      typeof candidate === "object"
    ) {
      const nested = [
        candidate.items,
        candidate.Items,

        candidate.data,
        candidate.Data,

        candidate.records,
        candidate.Records,

        candidate.result,
        candidate.Result,

        candidate.list,
        candidate.List,
      ];

      for (let item of nested) {
        item =
          parseMaybeJson(item);

        if (Array.isArray(item)) {
          return item;
        }
      }
    }
  }

  return [];
};

const extractStudentResponse = (response) => {
  const output = parseMaybeJson(
    response?.output ??
    response?.Output ??
    response?.data ??
    response?.Data ??
    response
  );

  let rows = extractList(output);

  if (rows.length === 0 && Array.isArray(output)) {
    rows = output;
  }

  const totals = [
    output?.totalRecords,
    output?.TotalRecords,
    output?.totalCount,
    output?.TotalCount,
    output?.recordCount,
    output?.RecordCount,
    output?.rowCount,
    output?.RowCount,

    response?.totalRecords,
    response?.TotalRecords,
    response?.totalCount,
    response?.TotalCount,
    response?.recordCount,
    response?.RecordCount,

    rows?.[0]?.totalRecords,
    rows?.[0]?.TotalRecords,
    rows?.[0]?.totalCount,
    rows?.[0]?.TotalCount,
    rows?.[0]?.recordCount,
    rows?.[0]?.RecordCount,
  ];

  let totalRecords = null;

  for (const value of totals) {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      const parsed = Number(value);

      if (Number.isFinite(parsed)) {
        totalRecords = parsed;
        break;
      }
    }
  }
  console.log("Pagination rows:", rows.length);
  console.log("Pagination totalRecords:", totalRecords);
  console.log("Pagination response:", response);

  if (!Number.isFinite(totalRecords)) {
    totalRecords = rows.length;
  }

  return {
    rows,
    totalRecords,
  };
};


// =========================================================
// EXTRACT SINGLE STUDENT FROM GET-BY-ID RESPONSE
// =========================================================

const extractStudentObject = (payload) => {
  if (!payload) {
    return null;
  }

  let root =
    parseMaybeJson(payload);

  let candidate =
    parseMaybeJson(
      root?.output ??
      root?.Output ??
      root?.data ??
      root?.Data ??
      root?.result ??
      root?.Result ??
      root
    );

  if (Array.isArray(candidate)) {
    return candidate[0] ?? null;
  }

  if (
    candidate &&
    typeof candidate === "object"
  ) {
    const nested =
      parseMaybeJson(
        candidate?.output ??
        candidate?.Output ??
        candidate?.data ??
        candidate?.Data ??
        candidate?.result ??
        candidate?.Result
      );

    if (Array.isArray(nested)) {
      return nested[0] ?? null;
    }

    if (
      nested &&
      typeof nested === "object"
    ) {
      return nested;
    }

    return candidate;
  }

  return null;
};


// =========================================================
// NORMALIZE STANDARD
// =========================================================

const normalizeStandard = (row) => ({
  ...row,

  id:
    row.id ??
    row.Id ??
    row.stdId ??
    row.StdId,

  name:
    row.stdName ??
    row.StdName ??
    row.standardName ??
    row.StandardName ??
    row.className ??
    row.ClassName ??
    row.name ??
    row.Name ??
    "",
});

// =========================================================
// NORMALIZE SCHOOL
// =========================================================

const normalizeSchool = (row) => ({
  ...row,

  id:
    row.id ??
    row.Id ??
    row.schoolId ??
    row.SchoolId,

  name:
    row.schoolName ??
    row.SchoolName ??
    row.name ??
    row.Name ??
    "",
});

// =========================================================
// NORMALIZE EXAM
// =========================================================

const normalizeExam = (row) => ({
  ...row,

  id:
    row.id ??
    row.Id ??
    row.examId ??
    row.ExamId ??
    row.examMasterId ??
    row.ExamMasterId,

  name:
    row.examName ??
    row.ExamName ??
    row.examTitle ??
    row.ExamTitle ??
    row.examType ??
    row.ExamType ??
    row.title ??
    row.Title ??
    row.description ??
    row.Description ??
    row.name ??
    row.Name ??
    "",
});

// =========================================================
// STUDENT DETAILS ARRAY
// =========================================================

const getStudentDetails = (row) => {
  let details =
    row.studentDetails ??
    row.StudentDetails ??
    row.studentDetail ??
    row.StudentDetail ??
    [];

  details =
    parseMaybeJson(details);

  if (Array.isArray(details)) {
    return details;
  }

  if (
    details &&
    typeof details === "object"
  ) {
    const nested =
      details.items ??
      details.Items ??
      details.data ??
      details.Data ??
      details.result ??
      details.Result ??
      details.records ??
      details.Records;

    const parsedNested =
      parseMaybeJson(nested);

    if (Array.isArray(parsedNested)) {
      return parsedNested;
    }
  }

  return [];
};

// =========================================================
// MAP STUDENT + MASTER DATA
// =========================================================

const mapApiStudent = (
  row,
  standards,
  schools,
  exams
) => {
  const firstName =
    row.firstName ??
    row.FirstName ??
    "";

  const middleName =
    row.middleName ??
    row.MiddleName ??
    "";

  const lastName =
    row.lastName ??
    row.LastName ??
    "";

  const generatedName = [
    firstName,
    middleName,
    lastName,
  ]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  // =======================================================
  // IDS
  // =======================================================

  const stdId =
    row.stdId ??
    row.StdId ??
    null;

  const schoolId =
    row.schoolId ??
    row.SchoolId ??
    null;

  const statusId =
    row.stdStatusId ??
    row.StdStatusId ??
    row.statusId ??
    row.StatusId ??
    0;

  // =======================================================
  // STANDARD NAME
  // =======================================================

  const standard =
    standards.find(
      (item) =>
        Number(item.id) ===
        Number(stdId)
    );

  const className =
    row.stdName ??
    row.StdName ??
    row.standardName ??
    row.StandardName ??
    row.className ??
    row.ClassName ??
    standard?.name ??
    "";

  // =======================================================
  // SCHOOL NAME
  // =======================================================

  const school =
    schools.find(
      (item) =>
        Number(item.id) ===
        Number(schoolId)
    );

  const schoolName =
    row.schoolName ??
    row.SchoolName ??
    school?.name ??
    "";

  // =======================================================
  // STUDENT DETAILS
  // =======================================================

  const studentDetails =
    getStudentDetails(row).filter(
      (detail) => {
        const active =
          detail?.isActive ??
          detail?.IsActive;

        return (
          active === undefined ||
          active === null ||
          active === true ||
          active === 1 ||
          active === "1" ||
          String(active).toLowerCase() ===
          "true"
        );
      }
    );

  // =======================================================
  // EXAM NAMES
  // =======================================================

  const examNames = [];

  for (
    const detail of
    studentDetails
  ) {
    const examId =
      detail.examId ??
      detail.ExamId;

    const directName =
      detail.examName ??
      detail.ExamName;

    if (directName) {
      examNames.push(
        directName
      );

      continue;
    }

    const exam =
      exams.find(
        (item) =>
          Number(item.id) ===
          Number(examId)
      );

    if (exam?.name) {
      examNames.push(
        exam.name
      );
    }
  }

  /*
    काही student API response मध्ये exams
    direct array / ids म्हणून असल्यास fallback.
  */
  let directExams =
    row.exams ??
    row.Exams ??
    row.examIds ??
    row.ExamIds ??
    [];

  directExams =
    parseMaybeJson(directExams);

  if (
    typeof directExams === "string" &&
    directExams.trim()
  ) {
    directExams = directExams
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (
    examNames.length === 0 &&
    Array.isArray(directExams)
  ) {
    directExams.forEach(
      (item) => {
        // Direct exam name string OR numeric id as string
        if (
          typeof item === "string" ||
          typeof item === "number"
        ) {
          const byId =
            exams.find(
              (exam) =>
                Number(exam.id) ===
                Number(item)
            );

          if (byId?.name) {
            examNames.push(byId.name);
          } else if (
            typeof item === "string" &&
            Number.isNaN(Number(item))
          ) {
            examNames.push(item);
          }

          return;
        }

        const itemExamId =
          item?.examId ??
          item?.ExamId ??
          item?.id ??
          item?.Id;

        const directName =
          item?.examName ??
          item?.ExamName ??
          item?.examTitle ??
          item?.ExamTitle ??
          item?.name ??
          item?.Name;

        if (directName) {
          examNames.push(directName);
          return;
        }

        if (
          itemExamId !== undefined &&
          itemExamId !== null
        ) {
          const exam =
            exams.find(
              (masterExam) =>
                Number(masterExam.id) ===
                Number(itemExamId)
            );

          if (exam?.name) {
            examNames.push(exam.name);
          }
        }
      }
    );
  }

  // Some APIs return a single ExamId directly on student row.
  if (examNames.length === 0) {
    const directExamId =
      row.examId ??
      row.ExamId;

    if (
      directExamId !== undefined &&
      directExamId !== null
    ) {
      const exam =
        exams.find(
          (item) =>
            Number(item.id) ===
            Number(directExamId)
        );

      if (exam?.name) {
        examNames.push(exam.name);
      }
    }
  }

  const uniqueExamNames =
    [...new Set(examNames)];

  // =======================================================
  // PENDING FEE
  // =======================================================

  const pendingFee =
    studentDetails.reduce(
      (total, detail) => {
        const directPending =
          detail.pendingFees ??
          detail.PendingFees;

        if (
          directPending !== undefined &&
          directPending !== null
        ) {
          return (
            total +
            numberValue(
              directPending
            )
          );
        }

        const totalFee =
          numberValue(
            detail.examTotalFees ??
            detail.ExamTotalFees
          );

        const paid =
          numberValue(
            detail.feesPaid ??
            detail.FeesPaid
          );

        return (
          total +
          Math.max(
            0,
            totalFee - paid
          )
        );
      },
      0
    );

  // =======================================================
  // STATUS
  // =======================================================

  const statusText =
    String(
      row.status ??
      row.Status ??
      row.stdStatusName ??
      row.StdStatusName ??
      ""
    ).toLowerCase();

  let status;

  if (
    statusText.includes(
      "drop"
    )
  ) {
    status = "dropped";
  } else if (
    statusText.includes(
      "active"
    ) ||
    statusText.includes(
      "enroll"
    )
  ) {
    status = "active";
  } else {
    status =
      Number(statusId) ===
        ACTIVE_STATUS_ID
        ? "active"
        : "dropped";
  }

  return {
    ...row,

    id:
      row.id ??
      row.Id,

    name:
      row.fullName ??
      row.FullName ??
      generatedName,

    roll:
      row.documentNo ??
      row.DocumentNo ??
      row.rollNo ??
      row.RollNo ??
      "",

    stdId,

    class:
      className,

    schoolId,

    schoolName,

    statusId,

    status,

    exams:
      uniqueExamNames,

    studentDetails,

    /*
      Exact pending fee from tbl_StudentDetails.
      Keep 0 as 0 - do not fall back to school/master fee.
    */
    pendingFee,

    fee:
      studentDetails.length > 0
        ? pendingFee
        : numberValue(
          row.pendingFee ??
          row.PendingFee ??
          row.pendingFees ??
          row.PendingFees ??
          row.fee ??
          row.Fee ??
          row.totalFee ??
          row.TotalFee
        ),

    phone:
      row.phone ??
      row.Phone ??
      row.mobileNo ??
      row.MobileNo ??
      row.fatherPhone ??
      row.FatherPhone ??
      "",

    email:
      row.email ??
      row.Email ??
      row.fatherEmail ??
      row.FatherEmail ??
      "",

    payments:
      row.payments ??
      row.Payments ??
      [],
  };
};

// =========================================================
// CLASS LABEL
// =========================================================

const getClassLabel = (value) => {
  if (!value) {
    return "—";
  }

  const text =
    String(value).trim();

  if (
    /^class\s/i.test(text)
  ) {
    return text;
  }

  return `Class ${text}`;
};

// =========================================================
// COMPONENT
// =========================================================

const dedupeStudentsById = (rows = []) => {
  const seen = new Set();

  return rows.filter((row) => {
    const id =
      row?.id ??
      row?.Id ??
      row?.studentId ??
      row?.StudentId;

    if (id === null || id === undefined || id === "") {
      return true;
    }

    const key = String(id);

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
};

export default function StudentsPage({
  students,
  setStudents,
  schools: parentSchools = [],
}) {
  // =======================================================
  // PAGE STATES
  // =======================================================

  const [sub, setSub] =
    useState("list");

  const [view, setView] =
    useState(null);

  const [edit, setEdit] =
    useState(null);

  const [del, setDel] =
    useState(null);

  // =======================================================
  // PAYMENT
  // =======================================================

  const [
    payStudent,
    setPayStudent,
  ] = useState(null);

  const [
    paymentAmount,
    setPaymentAmount,
  ] = useState("");

  const [
    paymentLoading,
    setPaymentLoading,
  ] = useState(false);

  // =======================================================
  // RAW STUDENTS
  // =======================================================

  const [
    rawStudents,
    setRawStudents,
  ] = useState([]);

  // =======================================================
  // MASTER DATA
  // =======================================================

  const [
    standards,
    setStandards,
  ] = useState([]);

  const [
    schoolList,
    setSchoolList,
  ] = useState([]);

  const [
    examList,
    setExamList,
  ] = useState([]);

  const [
    masterLoading,
    setMasterLoading,
  ] = useState(false);

  // =======================================================
  // SEARCH / PAGINATION
  // =======================================================

  const [q, setQ] =
    useState("");

  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);

  const [
    totalRecords,
    setTotalRecords,
  ] = useState(0);

  const [
    loadingStudents,
    setLoadingStudents,
  ] = useState(false);

  const [
    studentApiError,
    setStudentApiError,
  ] = useState("");

  // =======================================================
  // EFFECTIVE SCHOOL LIST
  // =======================================================

  const effectiveSchools =
    useMemo(() => {
      if (
        schoolList.length > 0
      ) {
        return schoolList;
      }

      return (
        parentSchools || []
      ).map(
        normalizeSchool
      );
    }, [
      schoolList,
      parentSchools,
    ]);

  // =======================================================
  // FETCH ONE MASTER API
  // =======================================================

  const fetchMasterList = async (
    url,
    normalizer,
    label = "Master"
  ) => {
    try {
      const response =
        await apiService.get(url);

      const data =
        parseMaybeJson(response.data);

      console.log(
        `${label} API raw response:`,
        data
      );

      const list =
        extractList(data);

      console.log(
        `${label} extracted list:`,
        list
      );

      const normalized =
        list.map(normalizer);

      console.log(
        `${label} normalized list:`,
        normalized
      );

      return normalized;
    } catch (error) {
      console.error(
        `${label} API error:`,
        error
      );

      const apiError =
        error?.response?.data;

      throw new Error(
        apiError?.failureReason ??
        apiError?.FailureReason ??
        apiError?.message ??
        apiError?.Message ??
        error?.message ??
        `Failed to load ${label}`
      );
    }
  };

  const fetchMasters =
    useCallback(async () => {
      try {
        setMasterLoading(true);

        const [
          standardData,
          schoolData,
          examData,
        ] = await Promise.all([
          fetchMasterList(
            STANDARD_API,
            normalizeStandard,
            "Standard"
          ),

          fetchMasterList(
            SCHOOL_API,
            normalizeSchool,
            "School"
          ),

          fetchMasterList(
            EXAM_API,
            normalizeExam,
            "Exam"
          ),
        ]);

        setStandards(
          standardData
        );

        setSchoolList(
          schoolData
        );

        setExamList(
          examData
        );

        console.log(
          "Standards API Data:",
          standardData
        );

        console.log(
          "Schools API Data:",
          schoolData
        );

        console.log(
          "Exams API Data:",
          examData
        );
      } catch (error) {
        console.error(
          "Master API error:",
          error
        );

        showNotification(
          "error",
          getApiErrorMessage(
            error,
            "Unable to load master data"
          )
        );
      } finally {
        setMasterLoading(false);
      }
    }, []);

  // =======================================================
  // LOAD MASTER DATA ONCE
  // =======================================================

  useEffect(() => {
    fetchMasters();
  }, [fetchMasters]);

  const fetchStudentById =
    useCallback(
      async (studentId) => {
        if (!studentId) {
          return null;
        }

        try {
          const response =
            await apiService.get(
              `${GET_STUDENT_BY_ID_API}/${encodeURIComponent(
                studentId
              )}`
            );

          const data =
            parseMaybeJson(
              response?.data
            );

          if (
            data?.isSuccess === false ||
            data?.IsSuccess === false
          ) {
            throw new Error(
              data?.failureReason ??
              data?.FailureReason ??
              data?.message ??
              data?.Message ??
              `Unable to load student ${studentId}`
            );
          }

          return extractStudentObject(
            data
          );
        } catch (error) {
          console.error(
            `Get Student By Id Error (${studentId}):`,
            error
          );

          throw new Error(
            getApiErrorMessage(
              error,
              `Unable to load student ${studentId}`
            )
          );
        }
      },
      []
    );


  const storedUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const currentUserId = Number(
    sessionStorage.getItem("userId") ??
    storedUser?.userId ??
    storedUser?.UserId ??
    0
  );

  const currentTeacherId = Number(
    sessionStorage.getItem("teacherId") ??
    storedUser?.teacherId ??
    storedUser?.TeacherId ??
    0
  );

  const fetchStudents =
    useCallback(async () => {
      try {
        setLoadingStudents(true);
        setStudentApiError("");

        const payload = {
          page: currentPage,
          pageSize: ITEMS_PER_PAGE,
          searchTerm: q.trim(),
          sortDirection: "desc",
          sortField: "Id",

          userId: 0,
          teacherId: currentTeacherId,
        };

        console.log(
          "Student API request:",
          payload
        );

        const response =
          await apiService.post(
            STUDENT_API,
            payload
          );

        const data =
          parseMaybeJson(
            response.data
          );

        console.log(
          "Student API response:",
          data
        );

        if (
          data?.isSuccess === false ||
          data?.IsSuccess === false
        ) {
          throw new Error(
            data?.failureReason ??
            data?.FailureReason ??
            data?.message ??
            data?.Message ??
            "Unable to load students"
          );
        }

        const {
          rows,
          totalRecords: total,
        } =
          extractStudentResponse(
            data
          );

        console.log(
          "Raw student rows:",
          rows
        );

        console.log(
          "FIRST STUDENT FULL:",
          rows?.[0] ?? null
        );

        console.log(
          "FIRST STUDENT DETAILS:",
          rows?.[0]?.studentDetails ??
          rows?.[0]?.StudentDetails ??
          null
        );

        console.log(
          "FIRST STUDENT EXAMS:",
          rows?.[0]?.exams ??
          rows?.[0]?.Exams ??
          null
        );

        const enrichedRows =
          await Promise.all(
            rows.map(async (row) => {
              const studentId =
                row?.id ??
                row?.Id;

              if (!studentId) {
                return row;
              }

              try {
                const fullStudent =
                  await fetchStudentById(
                    studentId
                  );

                if (!fullStudent) {
                  return row;
                }

                return {
                  ...row,
                  ...fullStudent,

                  id:
                    fullStudent?.id ??
                    fullStudent?.Id ??
                    row?.id ??
                    row?.Id,

                  Id:
                    fullStudent?.Id ??
                    fullStudent?.id ??
                    row?.Id ??
                    row?.id,
                };
              } catch (detailError) {
                console.warn(
                  `GetById failed for StudentId ${studentId}:`,
                  detailError
                );

                return row;
              }
            })
          );

        console.log(
          "Enriched student rows:",
          enrichedRows
        );

        const mappedStudents =
          enrichedRows.map((row) => ({
            ...row,

            paymentStatus:
              getPaymentStatus(row),
          }));

        const uniqueStudents =
          dedupeStudentsById(
            mappedStudents
          );

        setRawStudents(
          uniqueStudents
        );

        setTotalRecords(
          total
        );
      } catch (error) {
        console.error(
          "Student API error:",
          error
        );

        const apiError =
          error?.response?.data;

        setRawStudents([]);
        setStudents([]);
        setTotalRecords(0);

        const message =
          apiError?.failureReason ??
          apiError?.FailureReason ??
          apiError?.message ??
          apiError?.Message ??
          error?.message ??
          "Unable to load students";

        setStudentApiError(
          message
        );

        showNotification(
          "error",
          message
        );
      } finally {
        setLoadingStudents(false);
      }
    }, [
      currentPage,
      q,
      setStudents,
      fetchStudentById,
    ]);

  // =======================================================
  // STUDENT API DEBOUNCE
  // =======================================================

  useEffect(() => {
    const timer =
      setTimeout(() => {
        fetchStudents();
      }, 350);

    return () =>
      clearTimeout(timer);
  }, [fetchStudents]);

  // =======================================================
  // MAP STUDENT IDs TO MASTER NAMES
  // =======================================================

  const mappedStudents =
    useMemo(() => {
      return rawStudents.map(
        (row) =>
          mapApiStudent(
            row,
            standards,
            effectiveSchools,
            examList
          )
      );
    }, [
      rawStudents,
      standards,
      effectiveSchools,
      examList,
    ]);

  // =======================================================
  // EXAM DEBUG - TEMPORARY
  // =======================================================

  useEffect(() => {
    if (rawStudents.length === 0) {
      return;
    }

    console.log(
      "EXAM MASTER:",
      examList
    );

    console.log(
      "FIRST STUDENT MAPPED:",
      mappedStudents?.[0] ?? null
    );

    if (
      examList.length > 0 &&
      mappedStudents.length > 0 &&
      (mappedStudents[0]?.exams?.length ?? 0) === 0
    ) {
      console.warn(
        "Exam master loaded, but no exam relation found for first student. Check StudentDetails/ExamId in Student API response."
      );
    }
  }, [
    rawStudents,
    examList,
    mappedStudents,
  ]);

  // =======================================================
  // UPDATE PARENT STUDENTS
  // =======================================================

  useEffect(() => {
    setStudents(
      mappedStudents
    );
  }, [
    mappedStudents,
    setStudents,
  ]);

  // =======================================================
  // TOTAL PAGES
  // =======================================================

  const totalPages =
    Math.max(
      1,
      Math.ceil(
        totalRecords /
        ITEMS_PER_PAGE
      )
    );

  useEffect(() => {
    if (
      currentPage >
      totalPages
    ) {
      setCurrentPage(
        totalPages
      );
    }
  }, [
    currentPage,
    totalPages,
  ]);

  // =======================================================
  // PAGE NUMBERS
  // =======================================================

  const pageNumbers =
    useMemo(() => {
      return Array.from(
        {
          length:
            totalPages,
        },
        (_, index) =>
          index + 1
      );
    }, [totalPages]);

  // =======================================================
  // SHOWING
  // =======================================================

  const showingFrom =
    totalRecords === 0
      ? 0
      : (currentPage - 1) *
      ITEMS_PER_PAGE +
      1;

  const showingTo =
    totalRecords === 0
      ? 0
      : Math.min(
        showingFrom +
        mappedStudents.length -
        1,
        totalRecords
      );

  // =======================================================
  // SEARCH
  // =======================================================

  const handleSearch = (
    value
  ) => {
    setQ(value);
    setCurrentPage(1);
  };

  // =======================================================
  // DELETE
  // =======================================================

  const doDelete = async () => {
    if (!del) {
      return;
    }

    const studentId =
      del.id ??
      del.Id;

    if (!studentId) {
      showNotification(
        "error",
        "StudentId not found"
      );
      return;
    }

    try {
      console.log(
        "Delete Student ID:",
        studentId
      );

      const response =
        await apiService.delete(
          `${DELETE_STUDENT_API}/${encodeURIComponent(
            studentId
          )}`
        );

      const data =
        parseMaybeJson(
          response.data
        );

      console.log(
        "Delete Student Response:",
        data
      );

      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          data?.failureReason ??
          data?.FailureReason ??
          data?.message ??
          data?.Message ??
          "Unable to delete student"
        );
      }

      setRawStudents(
        (prev) =>
          prev.filter(
            (student) =>
              Number(
                student.id ??
                student.Id
              ) !==
              Number(studentId)
          )
      );

      setTotalRecords(
        (prev) =>
          Math.max(
            0,
            prev - 1
          )
      );

      setDel(null);

      showNotification(
        "success",
        "Student deleted successfully!"
      );

      await fetchStudents();
    } catch (error) {
      console.error(
        "Delete Student Error:",
        error
      );

      const apiError =
        error?.response?.data;

      showNotification(
        "error",
        apiError?.failureReason ??
        apiError?.FailureReason ??
        apiError?.message ??
        apiError?.Message ??
        error?.message ??
        "Unable to delete student"
      );
    }
  };

  // =======================================================
  // GET STUDENT FEE
  // =======================================================

  const getStudentFee = (
    student
  ) => {
    if (!student) {
      return 0;
    }

    /*
      GetById -> StudentDetails is the authoritative source.
      IMPORTANT: a real pending fee of 0 must remain 0.
    */
    const directPending =
      student.pendingFee ??
      student.PendingFee ??
      student.pendingFees ??
      student.PendingFees;

    if (
      directPending !==
      undefined &&
      directPending !== null &&
      directPending !== ""
    ) {
      return numberValue(
        directPending
      );
    }

    const details =
      getStudentDetails(
        student
      ).filter(
        (detail) => {
          const active =
            detail?.isActive ??
            detail?.IsActive;

          return (
            active === undefined ||
            active === null ||
            active === true ||
            active === 1 ||
            active === "1" ||
            String(active).toLowerCase() ===
            "true"
          );
        }
      );

    if (details.length > 0) {
      return details.reduce(
        (total, detail) => {
          const pending =
            detail?.pendingFees ??
            detail?.PendingFees;

          if (
            pending !==
            undefined &&
            pending !== null
          ) {
            return (
              total +
              numberValue(
                pending
              )
            );
          }

          const totalFee =
            numberValue(
              detail
                ?.examTotalFees ??
              detail
                ?.ExamTotalFees
            );

          const paidFee =
            numberValue(
              detail?.feesPaid ??
              detail?.FeesPaid
            );

          return (
            total +
            Math.max(
              0,
              totalFee -
              paidFee
            )
          );
        },
        0
      );
    }

    /*
      Legacy fallback only when StudentDetails are unavailable.
    */
    return numberValue(
      student.fee ??
      student.totalFee ??
      student.examFee ??
      student.studentFee ??
      student.schoolFee ??
      0
    );
  };

  // =======================================================
  // FORMAT INR
  // =======================================================

  const formatFee = (
    amount
  ) => {
    return new Intl.NumberFormat(
      "en-IN",
      {
        style:
          "currency",

        currency:
          "INR",

        maximumFractionDigits:
          2,
      }
    ).format(
      Number(
        amount || 0
      )
    );
  };

  // =======================================================
  // OPEN PAYMENT
  // =======================================================

  const openPayment = async (student) => {
    const studentId =
      student?.id ??
      student?.Id;

    if (!studentId) {
      showNotification(
        "error",
        "StudentId not found"
      );
      return;
    }

    try {
      setPaymentLoading(true);

      const fullStudent =
        await fetchStudentById(studentId);

      const mergedStudent = {
        ...student,
        ...(fullStudent || {}),
      };

      const mappedStudent =
        mapApiStudent(
          mergedStudent,
          standards,
          effectiveSchools,
          examList
        );

      const studentDetails =
        mappedStudent?.stdDetlst ??
        mappedStudent?.studentDetails ??
        [];

      if (!Array.isArray(studentDetails) || studentDetails.length === 0) {
        showNotification(
          "error",
          "Student details not found"
        );
        return;
      }

      /*
        Select every active exam detail that has pending fees.
      */
      const pendingDetails = studentDetails.filter((detail) => {
        const pendingFees = Number(
          detail?.pendingFees ??
          detail?.PendingFees ??
          detail?.pendingFee ??
          0
        );

        const isActive =
          detail?.isActive ??
          detail?.IsActive ??
          true;

        return isActive && pendingFees > 0;
      });

      if (pendingDetails.length === 0) {
        showNotification(
          "error",
          "No pending fees available for this student"
        );
        return;
      }

      /*
        Store every selected StudentDetail ID.
      */
      const studentDetailIds = pendingDetails
        .map((detail) =>
          Number(
            detail?.id ??
            detail?.Id
          )
        )
        .filter((id) => id > 0);

      /*
        Calculate the combined amount.
      */
      const combinedAmount = pendingDetails.reduce(
        (total, detail) => {
          const pendingFees = Number(
            detail?.pendingFees ??
            detail?.PendingFees ??
            detail?.pendingFee ??
            0
          );

          return total + pendingFees;
        },
        0
      );

      if (studentDetailIds.length === 0) {
        showNotification(
          "error",
          "Student detail IDs are missing"
        );
        return;
      }

      if (combinedAmount <= 0) {
        showNotification(
          "error",
          "No pending amount available"
        );
        return;
      }

      console.log(
        "PENDING STUDENT DETAILS:",
        pendingDetails
      );

      console.log(
        "SELECTED STUDENT DETAIL IDS:",
        studentDetailIds
      );

      console.log(
        "COMBINED PAYMENT AMOUNT:",
        combinedAmount
      );

      setPayStudent({
        ...mappedStudent,

        studentDetailIds,

        selectedStudentDetails: pendingDetails,

        pendingFee: combinedAmount,

        pendingFees: combinedAmount,
      });

      setPaymentAmount(
        String(combinedAmount)
      );
    } catch (error) {
      console.error(
        "Open payment detail error:",
        error
      );

      showNotification(
        "error",
        error?.message ||
        "Unable to load student fee details"
      );
    } finally {
      setPaymentLoading(false);
    }
  };

  const closePayment = () => {
    if (
      paymentLoading
    ) {
      return;
    }

    setPayStudent(null);
    setPaymentAmount("");
  };

  // =======================================================
  // LOAD RAZORPAY
  // =======================================================

  const loadRazorpayScript =
    () => {
      return new Promise(
        (resolve) => {
          if (
            typeof window ===
            "undefined"
          ) {
            resolve(false);
            return;
          }

          if (
            window.Razorpay
          ) {
            resolve(true);
            return;
          }

          const existing =
            document.querySelector(
              'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
            );

          if (existing) {
            existing.addEventListener(
              "load",
              () =>
                resolve(
                  true
                )
            );

            existing.addEventListener(
              "error",
              () =>
                resolve(
                  false
                )
            );

            return;
          }

          const script =
            document.createElement(
              "script"
            );

          script.src =
            "https://checkout.razorpay.com/v1/checkout.js";

          script.async =
            true;

          script.onload =
            () =>
              resolve(
                true
              );

          script.onerror =
            () =>
              resolve(
                false
              );

          document.body.appendChild(
            script
          );
        }
      );
    };

  // =======================================================
  // PAYMENT SUCCESS
  // =======================================================

  const markPaymentSuccessful =
    ({
      paymentId = "",
      orderId = "",
      signature = "",
      paidAmount = null,
    } = {}) => {
      if (!payStudent) {
        return;
      }

      const amount =
        Number(
          paidAmount ??
          paymentAmount
        );

      if (
        !Number.isFinite(
          amount
        ) ||
        amount <= 0
      ) {
        showNotification(
          "error",
          "Invalid payment amount"
        );

        setPaymentLoading(false);
        return;
      }

      setStudents(
        (prev) =>
          prev.map(
            (student) =>
              Number(
                student.id
              ) ===
                Number(
                  payStudent.id
                )
                ? {
                  ...student,

                  payments: [
                    ...(
                      student.payments ||
                      []
                    ),

                    {
                      id:
                        Date.now(),

                      amount,

                      paymentId,

                      orderId,

                      signature,

                      method:
                        "Razorpay",

                      status:
                        "success",

                      paidAt:
                        new Date().toISOString(),
                    },
                  ],
                }
                : student
          )
      );

      showNotification(
        "success",
        `Payment successful for ${payStudent.name}!`
      );

      setPaymentLoading(
        false
      );

      setPayStudent(null);

      setPaymentAmount("");
    };

  // =======================================================
  // RAZORPAY
  // =======================================================

  /*const handleRazorpayPayment =
    async () => {
      if (!payStudent) {
        return;
      }

      const studentId =
        payStudent.id ??
        payStudent.Id;

      if (!studentId) {
        showNotification(
          "error",
          "StudentId not found"
        );
        return;
      }

      try {
        setPaymentLoading(
          true
        );

        const loaded =
          await loadRazorpayScript();

        if (!loaded) {
          throw new Error(
            "Razorpay checkout could not load"
          );
        }

        
        const response =
          await apiService.post(
            `${RAZORPAY_ORDER_API}?studentId=${encodeURIComponent(
              studentId
            )}`,
            {}
          );

        const responseData =
          parseMaybeJson(
            response.data
          );

        console.log(
          "Create Razorpay Order Response:",
          responseData
        );

        if (
          responseData?.isSuccess === false ||
          responseData?.IsSuccess === false
        ) {
          throw new Error(
            responseData?.failureReason ??
            responseData?.FailureReason ??
            responseData?.message ??
            responseData?.Message ??
            "Unable to create Razorpay order"
          );
        }

        
        let order =
          responseData?.output ??
          responseData?.Output ??
          responseData?.data ??
          responseData?.Data ??
          responseData;

        order =
          parseMaybeJson(order);

        const orderId =
          order?.orderId ??
          order?.OrderId ??
          order?.id ??
          order?.Id;

        const orderAmount =
          Number(
            order?.amount ??
            order?.Amount
          );

        const currency =
          order?.currency ??
          order?.Currency ??
          "INR";

        if (!orderId) {
          throw new Error(
            "Razorpay OrderId not found in API response"
          );
        }

        if (
          !Number.isFinite(
            orderAmount
          ) ||
          orderAmount <= 0
        ) {
          throw new Error(
            "Invalid payment amount returned by API"
          );
        }

        setPaymentAmount(
          String(orderAmount)
        );

        const options = {
          key:
            RAZORPAY_KEY_ID,

          amount:
            Math.round(
              orderAmount * 100
            ),

          currency,

          name:
            "GoreExam",

          description:
            "Exam Fee Payment",

          order_id:
            orderId,

          prefill: {
            name:
              payStudent.name ||
              "",

            email:
              payStudent.email ||
              "",

            contact:
              payStudent.phone ||
              "",
          },

          notes: {
            studentId:
              String(
                studentId
              ),

            studentName:
              payStudent.name ||
              "",

            class:
              String(
                payStudent.class ||
                ""
              ),

            school:
              String(
                payStudent.schoolName ||
                ""
              ),
          },

          theme: {
            color:
              "#3399cc",
          },

          handler:
            function (
              paymentResponse
            ) {
              console.log(
                "Razorpay Success:",
                paymentResponse
              );

              markPaymentSuccessful(
                {
                  paymentId:
                    paymentResponse
                      .razorpay_payment_id,

                  orderId:
                    paymentResponse
                      .razorpay_order_id,

                  signature:
                    paymentResponse
                      .razorpay_signature,

                  paidAmount:
                    orderAmount,
                }
              );
            },

          modal: {
            ondismiss:
              function () {
                setPaymentLoading(
                  false
                );
              },
          },
        };

        const razorpay =
          new window.Razorpay(
            options
          );

        razorpay.on(
          "payment.failed",
          function (
            response
          ) {
            console.error(
              "Razorpay Payment Failed:",
              response?.error
            );

            setPaymentLoading(
              false
            );

            showNotification(
              "error",
              response
                ?.error
                ?.description ||
                "Payment failed"
            );
          }
        );

        razorpay.open();
      } catch (error) {
        console.error(
          "Razorpay error:",
          error
        );

        setPaymentLoading(
          false
        );

        showNotification(
          "error",
          error?.message ||
            "Something went wrong while creating payment."
        );
      }
    };*/


  const handleRazorpayPayment = async () => {
    if (!payStudent?.id) {
      showNotification(
        "error",
        "Student ID is missing."
      );
      return;
    }

    if (
      !Array.isArray(
        payStudent?.studentDetailIds
      ) ||
      payStudent.studentDetailIds
        .length === 0
    ) {
      showNotification(
        "error",
        "Please select at least one exam."
      );
      return;
    }

    try {
      setPaymentLoading(true);

      const orderResponse =
        await apiService.post(
          RAZORPAY_ORDER_API,
          {
            studentId:
              payStudent.id,

            studentDetailIds:
              payStudent
                .studentDetailIds,
          }
        );

      const orderRoot =
        parseMaybeJson(
          orderResponse?.data
        );

      if (
        orderRoot?.isSuccess ===
        false ||
        orderRoot?.IsSuccess ===
        false
      ) {
        throw new Error(
          orderRoot
            ?.failureReason ??
          orderRoot
            ?.FailureReason ??
          orderRoot?.message ??
          orderRoot?.Message ??
          "Unable to create Razorpay order."
        );
      }

      const orderData =
        parseMaybeJson(
          orderRoot?.output ??
          orderRoot?.Output ??
          orderRoot?.data ??
          orderRoot?.Data ??
          orderRoot
        );

      console.log(
        "Create Razorpay Order Response:",
        orderData
      );

      const orderId =
        orderData?.orderId ??
        orderData?.OrderId ??
        orderData?.id ??
        orderData?.Id;

      const orderAmount =
        Number(
          orderData?.amount ??
          orderData?.Amount ??
          0
        );

      const currency =
        orderData?.currency ??
        orderData?.Currency ??
        "INR";

      if (!orderId) {
        throw new Error(
          "Razorpay OrderId not found in API response."
        );
      }

      if (
        !Number.isFinite(
          orderAmount
        ) ||
        orderAmount <= 0
      ) {
        throw new Error(
          "Invalid payment amount returned by API."
        );
      }

      /*
        This amount comes from the backend.
        It is the combined amount calculated from all selected
        StudentDetails.PendingFees values.
      */
      setPaymentAmount(
        String(orderAmount)
      );

      const razorpayLoaded =
        await loadRazorpayScript();

      if (
        !razorpayLoaded ||
        typeof window ===
        "undefined" ||
        !window.Razorpay
      ) {
        throw new Error(
          "Razorpay Checkout script is not loaded."
        );
      }

      const options = {
        key: RAZORPAY_KEY_ID,

        amount: Math.round(
          orderAmount * 100
        ),

        currency,

        name: "GoreExam",

        description:
          `Combined exam fee payment for Student ${payStudent.id}`,

        order_id:
          orderId,

        prefill: {
          name:
            payStudent?.name ??
            "",

          email:
            payStudent?.email ??
            "",

          contact:
            payStudent?.phone ??
            "",
        },

        notes: {
          studentId:
            String(
              payStudent.id
            ),

          studentDetailIds:
            payStudent
              .studentDetailIds
              .join(","),
        },

        handler:
          async function (
            response
          ) {
            try {
              setPaymentLoading(
                true
              );

              const verifyResponse =
                await apiService.post(
                  RAZORPAY_VERIFY_API,
                  {
                    orderId:
                      response
                        .razorpay_order_id,

                    razorpayPaymentId:
                      response
                        .razorpay_payment_id,

                    razorpaySignature:
                      response
                        .razorpay_signature,
                  }
                );

              const verifyData =
                parseMaybeJson(
                  verifyResponse?.data
                );

              console.log(
                "Verify Razorpay Payment Response:",
                verifyData
              );

              if (
                verifyData
                  ?.isSuccess ===
                false ||
                verifyData
                  ?.IsSuccess ===
                false
              ) {
                throw new Error(
                  verifyData
                    ?.failureReason ??
                  verifyData
                    ?.FailureReason ??
                  verifyData
                    ?.message ??
                  verifyData
                    ?.Message ??
                  "Payment verification failed."
                );
              }

              showNotification(
                "success",
                "Payment completed successfully."
              );

              closePayment();

              /*
                Refresh the students so the status and pending
                amount are updated.
              */
              await fetchStudents();
            } catch (error) {
              console.error(
                "Payment verification error:",
                error
              );

              showNotification(
                "error",
                getApiErrorMessage(
                  error,
                  "Payment verification failed."
                )
              );
            } finally {
              setPaymentLoading(
                false
              );
            }
          },

        modal: {
          ondismiss:
            function () {
              setPaymentLoading(
                false
              );
            },
        },

        theme: {
          color: "#2563eb",
        },
      };

      const razorpay =
        new window.Razorpay(
          options
        );

      razorpay.on(
        "payment.failed",
        function (response) {
          console.error(
            "Razorpay payment failed:",
            response?.error
          );

          showNotification(
            "error",
            response
              ?.error
              ?.description ||
            "Payment failed."
          );

          setPaymentLoading(
            false
          );
        }
      );

      razorpay.open();
    } catch (error) {
      console.error(
        "Razorpay order error:",
        error
      );

      showNotification(
        "error",
        getApiErrorMessage(
          error,
          "Unable to start payment."
        )
      );

      setPaymentLoading(
        false
      );
    }
  };


  // =======================================================
  // SAVE
  // =======================================================

  const doSave = async (
    data
  ) => {
    if (edit) {
      const editId =
        edit?.id ??
        edit?.Id;

      const updatedStudent = {
        ...edit,
        ...data,

        id:
          data?.id ??
          data?.Id ??
          editId,

        Id:
          data?.Id ??
          data?.id ??
          editId,
      };

      setRawStudents(
        (prev) =>
          dedupeStudentsById(
            prev.map(
              (student) =>
                Number(
                  student.id ??
                  student.Id
                ) ===
                  Number(editId)
                  ? updatedStudent
                  : student
            )
          )
      );

      showNotification(
        "success",
        "Student updated successfully!"
      );
    } else {
      const createdStudentId =
        data?.id ??
        data?.Id ??
        data?.studentId ??
        data?.StudentId ??
        data?.apiResponse
          ?.output
          ?.studentId
          ?.id ??
        data?.apiResponse
          ?.Output
          ?.StudentId
          ?.Id;

      let savedStudent = null;

      if (createdStudentId) {
        try {
          savedStudent =
            await fetchStudentById(
              createdStudentId
            );
        } catch (error) {
          console.warn(
            "Unable to reload newly added student:",
            error
          );
        }
      }

      const newStudent = {
        ...data,
        ...(savedStudent || {}),

        id:
          savedStudent?.id ??
          savedStudent?.Id ??
          createdStudentId ??
          Date.now(),

        Id:
          savedStudent?.Id ??
          savedStudent?.id ??
          createdStudentId ??
          undefined,

        status:
          savedStudent?.status ??
          savedStudent?.Status ??
          "active",

        IsActive:
          savedStudent?.IsActive ??
          savedStudent?.isActive ??
          true,

        examScores:
          data?.examScores ??
          [],

        payments:
          data?.payments ??
          [],
      };

      setRawStudents(
        (prev) => {
          const newId =
            newStudent.id ??
            newStudent.Id;

          const withoutDuplicate =
            newId
              ? prev.filter(
                (student) =>
                  Number(
                    student.id ??
                    student.Id
                  ) !==
                  Number(newId)
              )
              : prev;

          return dedupeStudentsById([
            newStudent,
            ...withoutDuplicate,
          ]);
        }
      );

      setTotalRecords(
        (prev) =>
          prev + 1
      );

      /*
        New records are returned by the API in descending Id order.
        Keep the UI on page 1 so the newly added student is visible
        immediately, just like the School page.
      */
      setCurrentPage(1);

      showNotification(
        "success",
        "Student added successfully!"
      );
    }

    setSub("list");
    setEdit(null);
  };

  // =======================================================
  // ADD
  // =======================================================

  if (sub === "add") {
    return (
      <StudentForm
        title="Add Student"
        schools={
          effectiveSchools
        }
        onSave={
          doSave
        }
        onBack={() =>
          setSub(
            "list"
          )
        }
      />
    );
  }

  // =======================================================
  // EDIT
  // =======================================================

  if (
    sub === "edit" &&
    edit
  ) {
    return (
      <StudentForm
        title="Edit Student"
        initial={edit}
        schools={
          effectiveSchools
        }
        onSave={
          doSave
        }
        onBack={() => {
          setSub(
            "list"
          );

          setEdit(null);
        }}
      />
    );
  }

  // =======================================================
  // VIEW
  // =======================================================

  if (
    sub === "view" &&
    view
  ) {
    const school =
      effectiveSchools.find(
        (item) =>
          Number(item.id) ===
          Number(
            view.schoolId
          )
      );

    return (
      <StudentView
        student={view}
        school={school}
        onBack={() => {
          setSub(
            "list"
          );

          setView(null);
        }}
        onEdit={(
          student
        ) => {
          setEdit(
            student
          );

          setSub(
            "edit"
          );
        }}
      />
    );
  }

  // =======================================================
  // UPLOAD
  // =======================================================

  if (
    sub === "upload"
  ) {
    return (
      <UploadExcel
        title="Upload Students"
        columns={[
          "Name",
          "Roll",
          "Class",
          "Exams",
          "School",
          "Gender",
          "Phone",
          "Email",
        ]}
        onBack={() =>
          setSub(
            "list"
          )
        }
        onSuccess={() => {
          setSub(
            "list"
          );

          setCurrentPage(
            1
          );

          fetchStudents();

          showNotification(
            "success",
            "Students imported successfully!"
          );
        }}
      />
    );
  }

  const getPaymentStatus = (student) => {
    const details =
      student?.studentDetails ??
      student?.StudentDetails ??
      student?.stdDetlst ??
      [];

    if (!Array.isArray(details) || details.length === 0) {
      return "pending";
    }

    const hasPendingFees = details.some((detail) => {
      const pendingFees = Number(
        detail?.pendingFees ??
        detail?.PendingFees ??
        0
      );

      return pendingFees > 0;
    });

    return hasPendingFees
      ? "pending"
      : "paid";
  };

  // =======================================================
  // MAIN
  // =======================================================

  return (
    <>
      <style>{`
        .students-pagination-footer {
          box-sizing: border-box;
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          align-items: center !important;
          justify-content: space-between !important;
          gap: 8px !important;
          min-width: 0;
          max-width: 100%;
        }
        .students-pagination-count {
          flex: 0 0 auto;
          white-space: nowrap;
        }
        .students-pagination-bar {
          display: flex !important;
          flex: 1 1 0;
          min-width: 0;
          max-width: 100%;
          align-items: center;
          justify-content: flex-end;
          gap: 5px;
          overflow: hidden;
        }
        .students-pagination-bar > button {
          flex: 0 0 auto;
          white-space: nowrap;
          padding: 0 7px;
        }
        .students-pagination-numbers {
          display: flex;
          flex: 0 1 auto;
          align-items: center;
          min-width: 0;
          max-width: 100%;
          gap: 4px;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          scrollbar-width: thin;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-x: contain;
        }
        .students-pagination-numbers > button {
          flex: 0 0 auto;
        }
        @media (max-width: 600px) {
          .students-pagination-footer { gap: 5px !important; padding-left: 0 !important; padding-right: 0 !important; }
          .students-pagination-count { font-size: 9px !important; }
          .students-pagination-bar { gap: 3px !important; }
          .students-pagination-bar > button { min-width: 44px !important; padding: 0 4px !important; font-size: 10px !important; }
          .students-pagination-numbers { flex: 1 1 0; gap: 3px; }
          .students-pagination-numbers > button { min-width: 28px !important; padding: 0 5px !important; }
        }
      `}</style>
      <div className="ph">
        <div className="ph-t">
          Students Management
        </div>
      </div>

      {/* TOOLBAR */}

      <div className="toolbar">
        <SB
          value={q}
          onChange={
            handleSearch
          }
          placeholder="Search students, roll no…"
        />

        <button
          type="button"
          className="btn btn-p"
          onClick={() => {
            setEdit(null);
            setSub("add");
          }}
        >
          <I
            n="plus"
            s={13}
            c="#fff"
          />

          Add Student
        </button>

        <button
          type="button"
          className="btn btn-o"
          onClick={() =>
            setSub(
              "upload"
            )
          }
        >
          <I
            n="upload"
            s={13}
            c="var(--p)"
          />

          Upload Excel
        </button>

        <button
          type="button"
          className="btn btn-g"
          style={{
            marginLeft:
              "auto",
          }}
          onClick={() => {
            fetchMasters();
            fetchStudents();
          }}
        >
          <I
            n="download"
            s={12}
          />

          Refresh
        </button>
      </div>

     

      {/* TABLE */}

      <div className="card">
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>
                  Student Name
                </th>

                <th>
                  Class
                </th>

                <th>
                  Exams
                </th>
                <th>
                  School
                </th>

                <th>
                  Payment Status
                </th>

                <th>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {loadingStudents ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign:
                        "center",

                      padding:
                        30,

                      color:
                        "var(--t3)",
                    }}
                  >
                    Loading
                    students...
                  </td>
                </tr>
              ) : studentApiError ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign:
                        "center",

                      padding:
                        30,

                      color:
                        "#dc2626",
                    }}
                  >
                    {
                      studentApiError
                    }
                  </td>
                </tr>
              ) : mappedStudents.length ===
                0 ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign:
                        "center",

                      padding:
                        28,

                      color:
                        "var(--t3)",
                    }}
                  >
                    🎓 No students
                    found
                  </td>
                </tr>
              ) : (
                mappedStudents.map(
                  (
                    student,
                    index
                  ) => (
                    <tr
                      key={
                        student.id ??
                        index
                      }
                    >
                      {/* NAME */}

                      <td>
                        <div
                          style={{
                            display:
                              "flex",

                            alignItems:
                              "center",

                            gap: 8,
                          }}
                        >
                          <div
                            className="av"
                            style={{
                              width:
                                27,

                              height:
                                27,

                              fontSize:
                                10,

                              background:
                                `hsl(${index *
                                55 +
                                190
                                },58%,52%)`,
                            }}
                          >
                            {student
                              .name?.[0] ||
                              "S"}
                          </div>

                          <div>
                            <div className="tdb">
                              {student.name ||
                                "—"}
                            </div>

                            {student.roll && (
                              <div
                                style={{
                                  marginTop:
                                    2,

                                  fontSize:
                                    10,

                                  color:
                                    "var(--t3)",
                                }}
                              >
                                {
                                  student.roll
                                }
                              </div>
                            )}
                          </div>
                        </div>
                      </td>

                      {/* CLASS NAME */}

                      <td>
                        <Bdg
                          type="blue"
                          label={
                            getClassLabel(
                              student.class
                            )
                          }
                        />
                      </td>

                      {/* EXAM NAMES */}

                      <td>
                        {student
                          .exams
                          ?.length >
                          0 ? (
                          <ExamPills
                            exams={
                              student.exams
                            }
                          />
                        ) : (
                          <span
                            style={{
                              color:
                                "var(--t3)",
                            }}
                          >
                            —
                          </span>
                        )}
                      </td>

                      {/* SCHOOL NAME */}

                      <td className="td2">
                        {student.schoolName ||
                          "—"}
                      </td>

                      {/* STATUS */}

                      <td>
                        {student.paymentStatus === "paid" ? (
                          <Bdg
                            type="green"
                            label="Paid"
                          />
                        ) : (
                          <button
                            type="button"
                            title={`Pay fee for ${student.name}`}
                            onClick={() => openPayment(student)}
                            style={{
                              border: 0,
                              padding: 0,
                              background: "transparent",
                              cursor: "pointer",
                            }}
                          >
                            <Bdg
                              type="yellow"
                              label="Pending"
                            />
                          </button>
                        )}
                      </td>

                      {/* ACTIONS */}

                      <td>
                        <div className="ra">
                          <button
                            type="button"
                            className="btn btn-g btn-sm"
                            onClick={() => {
                              setView(
                                student
                              );

                              setSub(
                                "view"
                              );
                            }}
                          >
                            <I
                              n="eye"
                              s={11}
                            />
                          </button>

                          <button
                            type="button"
                            className="btn btn-g btn-sm"
                            onClick={() => {
                              setEdit(
                                student
                              );

                              setSub(
                                "edit"
                              );
                            }}
                          >
                            <I
                              n="edit"
                              s={11}
                            />
                          </button>

                          <button
                            type="button"
                            className="btn btn-d btn-sm"
                            onClick={() =>
                              setDel(
                                student
                              )
                            }
                          >
                            <I
                              n="trash"
                              s={11}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )
              )}
            </tbody>
          </table>

        </div>

          {/* PAGINATION */}

          {!loadingStudents &&
            !studentApiError &&
            totalRecords >
            0 && (
              <div
                className="students-pagination-footer"
                style={{
                  width:
                    "100%",

                  display:
                    "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "space-between",

                  gap: 16,

                  marginTop:
                    16,

                  padding:
                    "12px 4px 4px",

                  borderTop:
                    "1px solid #eef2f7",
                }}
              >
                <div
                  className="students-pagination-count"
                  style={{
                    fontSize:
                      11,

                    color:
                      "var(--t3)",
                  }}
                >
                  Showing{" "}

                  <b>
                    {
                      showingFrom
                    }
                  </b>

                  {" – "}

                  <b>
                    {
                      showingTo
                    }
                  </b>

                  {" of "}

                  <b>
                    {
                      totalRecords
                    }
                  </b>
                </div>

                <div
                  className="students-pagination-bar"
                  style={{
                    display:
                      "flex",

                    alignItems:
                      "center",

                    gap: 5,
                  }}
                >
                  <button
                    type="button"
                    disabled={
                      currentPage ===
                      1
                    }
                    onClick={() =>
                      setCurrentPage(
                        (page) =>
                          Math.max(
                            1,
                            page -
                            1
                          )
                      )
                    }
                    style={{
                      height:
                        32,

                      minWidth:
                        66,

                      border:
                        "1px solid #e2e8f0",

                      borderRadius:
                        6,

                      background:
                        "#fff",

                      cursor:
                        currentPage ===
                          1
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    ‹ Back
                  </button>

                  <div className="students-pagination-numbers">
                  {pageNumbers.map(
                    (page) => (
                      <button
                        key={
                          page
                        }
                        type="button"
                        onClick={() =>
                          setCurrentPage(
                            page
                          )
                        }
                        style={{
                          height:
                            32,

                          minWidth:
                            32,

                          border:
                            currentPage ===
                              page
                              ? "1px solid #2563eb"
                              : "1px solid #e2e8f0",

                          borderRadius:
                            6,

                          background:
                            currentPage ===
                              page
                              ? "#2563eb"
                              : "#fff",

                          color:
                            currentPage ===
                              page
                              ? "#fff"
                              : "#475569",

                          cursor:
                            "pointer",
                        }}
                      >
                        {
                          page
                        }
                      </button>
                    )
                  )}
                  </div>

                  <button
                    type="button"
                    disabled={
                      currentPage ===
                      totalPages
                    }
                    onClick={() =>
                      setCurrentPage(
                        (page) =>
                          Math.min(
                            totalPages,
                            page +
                            1
                          )
                      )
                    }
                    style={{
                      height:
                        32,

                      minWidth:
                        66,

                      border:
                        "1px solid #e2e8f0",

                      borderRadius:
                        6,

                      background:
                        "#fff",

                      cursor:
                        currentPage ===
                          totalPages
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Next ›
                  </button>
                </div>
              </div>
            )}
      </div>

      {/* DELETE */}

      {del && (
        <ConfirmDlg
          title="Remove Student"
          msg={`Remove "${del.name}"?`}
          onOk={doDelete}
          onCancel={() =>
            setDel(null)
          }
        />
      )}

      {/* PAYMENT POPUP */}

      {payStudent &&
        typeof document !==
        "undefined" &&
        createPortal(
          <div
            onClick={(event) => {
              if (
                event.target ===
                event.currentTarget
              ) {
                closePayment();
              }
            }}
            style={{
              position:
                "fixed",

              inset: 0,

              zIndex:
                999999,

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",

              padding: 20,

              background:
                "rgba(15,23,42,.58)",
            }}
          >
            <div
              style={{
                width:
                  "100%",

                maxWidth:
                  440,

                background:
                  "#fff",

                borderRadius:
                  15,

                overflow:
                  "hidden",

                boxShadow:
                  "0 25px 80px rgba(0,0,0,.28)",
              }}
            >
              {/* PAYMENT HEADER */}

              <div
                style={{
                  padding:
                    "17px 18px",

                  display:
                    "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "space-between",

                  borderBottom:
                    "1px solid #e8edf3",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize:
                        17,

                      fontWeight:
                        700,
                    }}
                  >
                    Fee Payment
                  </div>

                  <div
                    style={{
                      marginTop:
                        3,

                      fontSize:
                        11,

                      color:
                        "#64748b",
                    }}
                  >
                    Pay securely
                    using Razorpay
                  </div>
                </div>

                <button
                  type="button"
                  disabled={
                    paymentLoading
                  }
                  onClick={
                    closePayment
                  }
                  style={{
                    width:
                      34,

                    height:
                      34,

                    border:
                      "1px solid #e2e8f0",

                    borderRadius:
                      8,

                    background:
                      "#fff",

                    cursor:
                      "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              {/* PAYMENT BODY */}

              <div
                style={{
                  padding:
                    18,
                }}
              >
                <div
                  style={{
                    padding:
                      15,

                    marginBottom:
                      18,

                    background:
                      "#f8fafc",

                    border:
                      "1px solid #e2e8f0",

                    borderRadius:
                      10,
                  }}
                >
                  <div
                    style={{
                      fontSize:
                        10,

                      color:
                        "#64748b",
                    }}
                  >
                    STUDENT
                  </div>

                  <div
                    style={{
                      marginTop:
                        5,

                      fontSize:
                        18,

                      fontWeight:
                        700,
                    }}
                  >
                    {
                      payStudent.name
                    }
                  </div>

                  <div
                    style={{
                      display:
                        "flex",

                      flexWrap:
                        "wrap",

                      gap:
                        12,

                      marginTop:
                        6,

                      fontSize:
                        12,

                      color:
                        "#64748b",
                    }}
                  >
                    {payStudent.class && (
                      <span>
                        {
                          getClassLabel(
                            payStudent.class
                          )
                        }
                      </span>
                    )}

                    {payStudent.schoolName && (
                      <span>
                        {
                          payStudent.schoolName
                        }
                      </span>
                    )}
                  </div>

                  {payStudent
                    .exams
                    ?.length >
                    0 && (
                      <div
                        style={{
                          marginTop:
                            10,
                        }}
                      >
                        <ExamPills
                          exams={
                            payStudent.exams
                          }
                        />
                      </div>
                    )}
                </div>

                <div
                  style={{
                    display:
                      "flex",

                    justifyContent:
                      "space-between",

                    alignItems:
                      "center",

                    marginBottom:
                      18,
                  }}
                >
                  <span>
                    Pending Fee
                  </span>

                  <strong
                    style={{
                      fontSize:
                        22,
                    }}
                  >
                    {formatFee(
                      getStudentFee(
                        payStudent
                      )
                    )}
                  </strong>
                </div>

                <label>
                  Amount to Pay
                </label>

                <input
                  type="number"
                  min="1"
                  value={
                    paymentAmount
                  }
                  readOnly
                  disabled={
                    paymentLoading
                  }
                  placeholder="Amount will be calculated by server"
                  style={{
                    width:
                      "100%",

                    height:
                      42,

                    marginTop:
                      6,

                    boxSizing:
                      "border-box",

                    padding:
                      "0 12px",

                    border:
                      "1px solid #cbd5e1",

                    borderRadius:
                      8,
                  }}
                />
              </div>

              {/* PAYMENT FOOTER */}

              <div
                style={{
                  padding:
                    "14px 18px",

                  display:
                    "flex",

                  justifyContent:
                    "flex-end",

                  gap: 8,

                  background:
                    "#f8fafc",

                  borderTop:
                    "1px solid #e8edf3",
                }}
              >
                <button
                  type="button"
                  className="btn btn-g"
                  disabled={
                    paymentLoading
                  }
                  onClick={
                    closePayment
                  }
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-p"
                  disabled={
                    paymentLoading ||
                    !payStudent?.id ||
                    !payStudent?.studentDetailIds?.length
                  }
                  onClick={handleRazorpayPayment}
                >
                  {paymentLoading ? "Processing..." : "Pay"}
                </button>
              </div>
            </div>
          </div>,

          document.body
        )}
    </>
  );
}